<template lang="pug">
nav#navBar(ref="navBar" :class="{ 'main-nav': routeName === 'home' || route.name === 'myservices' || route.name === 'accountsetting' }")
    .wrap
        .left
            template(v-if="route.name != 'home'")
                .logo-wrap
                    template(v-if="route.name === 'usecases'")
                        router-link.logo(to="/" data-track="navBar_logo_img")
                            img.symbol(src="@/assets/img/logo/icon_logo.svg" alt="Skapi logo")
                    template(v-else)
                        router-link.logo(to="/" data-track="navBar_logo_skapi_img" @click="handleLogoClick")
                            img.symbol(src="@/assets/img/logo/icon_logo_symbol.svg" alt="Skapi logo")
                        router-link.logo.myservice(to="/my-services" style='margin-left: 8px;') My Services
            template(v-else)
                .logo-wrap(style='font-weight: 500;font-size: 21px;')
                    router-link.logo(to="/" data-track="navBar_logo_img")
                        img.symbol(src="@/assets/img/logo/icon_logo_symbol.svg" alt="Skapi logo")
                        | Skapi
                ul.section-list(v-if="route.name === 'home'" ref="navSecEl")
                    li.section-item(@click="scrollSec('section1')" data-track="navBar_sec_features") Features
                    li.section-item(@click="scrollSec('section2')" data-track="navBar_sec_templates") Templates
                    li.section-item(@click="scrollSec('section3')" data-track="navBar_sec_price") Price
                    li.section-item(@click="scrollSec('section4')" data-track="navBar_sec_faq") FAQ
                    li.section-item(@click="scrollSec('section5')" data-track="navBar_sec_contents") Contents
        .right
            ul.menu-wrap(ref="navMenuEl")
                template(v-if="isDesktop")
                    template(v-if="user?.user_id")
                        li.list.go-community(ref="communityEl")
                            .dropdown-container(@mouseenter="showCommunityDropdown" @mouseleave="hideCommunityDropdown")
                                .ser.dropdown(@click.stop) Community
                                    img(src="@/assets/img/landingpage/icon_dropdown.svg" alt="Dropdown icon" style="width: .6875rem; height: 1.5rem;")
                                .moreVert.community(ref="moreVert" @click.stop :style="{ '--moreVert-right': 0, display: communityDropdownVisible ? 'block' : 'none' }")
                                    ul.list-wrap
                                        li.item
                                            a.link(href="http://www.tiktok.com/@skapi_api" target="_blank" data-track="navBar_tiktok_icon")
                                                img(src="@/assets/img/landingpage/icon_tiktok.svg" alt="TikTok icon")
                                        li.item
                                            a.link(href="https://www.instagram.com/skapi_api" target="_blank" data-track="navBar_instagram_icon")
                                                img(src="@/assets/img/landingpage/icon_instagram.svg" alt="Instagram icon")
                                        li.item
                                            a.link(href="https://www.youtube.com/@skapi_official" target="_blank" data-track="navBar_youtube_icon")
                                                img(src="@/assets/img/landingpage/icon_youtube.svg" alt="YouTube icon")
                                        li.item
                                            a.link(href="https://x.com/skapi_api" target="_blank" data-track="navBar_x_icon")
                                                img(src="@/assets/img/landingpage/icon_x.svg" alt="X (formerly Twitter) icon")
                                        li.item
                                            a.link(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank" data-track="navBar_linkedin_icon")
                                                img(src="@/assets/img/landingpage/icon_linkedin.svg" alt="LinkedIn icon")
                                        li.item
                                            a.link(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank" data-track="navBar_facebook_icon")
                                                img(src="@/assets/img/landingpage/icon_facebook.svg" alt="Facebook icon")
                                        li.item
                                            a.link(href="https://dev.to/skapi_api" target="_blank" data-track="navBar_devto_icon")
                                                img(src="@/assets/img/landingpage/icon_devto.svg" alt="Dev.to icon")
                        li.list.go-docs
                            a.ser(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" data-track="navBar_docs_icon") 
                                img(src="@/assets/img/landingpage/icon_docs.svg" alt="Docs icon")
                                | Docs
                        li.list.go-github
                            a.ser(href="https://github.com/broadwayinc/skapi-js" target="_blank" data-track="navBar_github_icon")
                                img(src="@/assets/img/landingpage/icon_github.svg" alt="Github icon")
                                | Github
                        li.list.go-service(v-if="route.name === 'home' || route.name === 'usecases'")
                            router-link.ser(to="/my-services" data-track="navBar_my_services_icon") 
                                img(src="@/assets/img/logo/symbol-logo-white.svg" alt="My Services icon")
                                | My Services
                        li.list.user-profile
                            .dropdown-container(@mouseenter="showProfileDropdown" @mouseleave="hideProfileDropdown")
                                .img-profile-wrap(@click.stop)
                                    img(src="@/assets/img/landingpage/icon_profile.svg" alt="User Profile icon")
                                .moreVert.profile(ref="moreVert" @click.stop :style="{ '--moreVert-right': 0, display: profileDropdownVisible ? 'block' : 'none' }")
                                    .account 
                                        span.user-id {{ userEmail.split("@")[0] }}
                                        | @{{ userEmail.split("@")[1] }}
                                    ul.dropdown-menu
                                        li.dropdown-list(@click="navigateToPage" data-track="navBar_accountSet")
                                            img(src="@/assets/img/landingpage/icon_setting.svg" alt="Account Settings icon")
                                            span Account Settings
                                        li.dropdown-list(@click="openBillingPage" data-track="navBar_billing")
                                            img(src="@/assets/img/landingpage/icon_billing.svg" alt="Billing icon")
                                            span Billing
                                        li.dropdown-list(@click="logout" data-track="navBar_logout")
                                            img(src="@/assets/img/landingpage/icon_logout.svg" alt="Logout icon")
                                            span Logout
                    template(v-else)
                        li.list.go-community(ref="communityEl")
                            .dropdown-container(@mouseenter="showCommunityDropdown" @mouseleave="hideCommunityDropdown")
                                .ser.dropdown(@click.stop) Community
                                    img(src="@/assets/img/landingpage/icon_dropdown.svg" alt="Dropdown icon" style="width: .6875rem; height: 1.5rem;")
                                    .moreVert.community(ref="moreVert" @click.stop :style="{ '--moreVert-right': 0, display: communityDropdownVisible ? 'block' : 'none' }")
                                        ul.list-wrap
                                            li.item
                                                a.link(href="http://www.tiktok.com/@skapi_api" target="_blank" data-track="navBar_tiktok_icon")
                                                    img(src="@/assets/img/landingpage/icon_tiktok.svg" alt="TikTok icon")
                                            li.item
                                                a.link(href="https://www.instagram.com/skapi_api" target="_blank" data-track="navBar_instagram_icon")
                                                    img(src="@/assets/img/landingpage/icon_instagram.svg" alt="Instagram icon")
                                            li.item
                                                a.link(href="https://www.youtube.com/@skapi_official" target="_blank" data-track="navBar_youtube_icon")
                                                    img(src="@/assets/img/landingpage/icon_youtube.svg" alt="YouTube icon")
                                            li.item
                                                a.link(href="https://x.com/skapi_api" target="_blank" data-track="navBar_x_icon")
                                                    img(src="@/assets/img/landingpage/icon_x.svg" alt="X (formerly Twitter) icon")
                                            li.item
                                                a.link(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank" data-track="navBar_linkedin_icon")
                                                    img(src="@/assets/img/landingpage/icon_linkedin.svg" alt="LinkedIn icon")
                                            li.item
                                                a.link(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank" data-track="navBar_facebook_icon")
                                                    img(src="@/assets/img/landingpage/icon_facebook.svg" alt="Facebook icon")
                                            li.item
                                                a.link(href="https://dev.to/skapi_api" target="_blank" data-track="navBar_devto_icon")
                                                    img(src="@/assets/img/landingpage/icon_devto.svg" alt="Dev.to icon")
                        li.list.go-docs
                            a.ser(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" data-track="navBar_docs_icon") 
                                img(src="@/assets/img/landingpage/icon_docs.svg" alt="Docs icon")
                                | Docs
                        li.list.go-github
                            a.ser(href="https://github.com/broadwayinc/skapi-js" target="_blank" data-track="navBar_github_icon") 
                                img(src="@/assets/img/landingpage/icon_github.svg" alt="Github icon")
                                | Github
                        li.list.go-login
                            router-link(to="/login" data-track="navBar_login_icon") 
                                img(src="@/assets/img/landingpage/icon_login.svg" alt="Login icon")
                                | Login

                template(v-else :class="{ 'mo' : true }")
                    button.btn-open-menu.nohover(@click="openMoMenu")
                        img(src="@/assets/img/landingpage/icon_menubar.svg" alt="Menu icon")
                    .mo-menu-wrap
                        .top-area
                            .logo
                                img.symbol.mobile(src="@/assets/img/logo/icon_logo.svg" alt="Logo" @click="router.push('/')")
                            .right-area
                                .prof
                                    template(v-if="user?.user_id" )
                                        .img-profile(@click.stop="(e)=>{showDropDown(e)}")
                                            .img-wrap
                                                img(src="@/assets/img/landingpage/icon_profile.svg" alt="Profile icon" style="width: 2.5rem; height: 2.5rem;")
                                            .moreVert.profile(ref="moreVert" @click.stop style="--moreVert-right:0;display:none")
                                                .account 
                                                    span.user-id {{ userEmail.split("@")[0] }}
                                                    | @{{ userEmail.split("@")[1] }}
                                                ul.dropdown-menu
                                                    li.dropdown-list(@click="navigateToPage" data-track="navBar_account_settings")
                                                        img(src="@/assets/img/landingpage/icon_setting.svg" alt="Account Settings icon")
                                                        span Account Settings
                                                    li.dropdown-list(@click="openBillingPage" data-track="navBar_billing")
                                                        img(src="@/assets/img/landingpage/icon_billing.svg" alt="Billing icon")
                                                        span Billing
                                                    li.dropdown-list(@click="logout" data-track="navBar_logout")
                                                        img(src="@/assets/img/landingpage/icon_logout.svg" alt="Logout icon")
                                                        span Logout
                                    template(v-else)
                                        router-link.go-login(to="/login" data-track="navBar_login_btn" @click="closeMobileMenu") 
                                            img(src="@/assets/img/landingpage/icon_login.svg" alt="Login icon")
                                            | Login
                                button.btn-close.nohover(@click="openMoMenu")
                                    img(src="@/assets/img/landingpage/icon_close.svg" alt="Close icon")

                        ul.section-list(v-if="route.name === 'home'")
                            li.section-item(@click="scrollSec('section1')" data-track="navBar_features_sec") Features
                            li.section-item(@click="scrollSec('section2')" data-track="navBar_templates_sec") Templates
                            li.section-item(@click="scrollSec('section3')" data-track="navBar_price_sec") Price
                            li.section-item(@click="scrollSec('section4')" data-track="navBar_faq_sec") FAQ
                            li.section-item(@click="scrollSec('section5')" data-track="navBar_contents_sec") Contents
                        SideNav(v-if="currentRoutePath === 'my-services'" @closeMobileMenu="closeMobileMenu")
                        ul.menu-list
                            li.list.go-docs.mo-item
                                a.ser(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" data-track="navBar_docs_icon" @click="closeMobileMenu") 
                                    img(src="@/assets/img/landingpage/icon_docs.svg" alt="Docs icon")
                                    | Docs
                            li.list.go-github.mo-item
                                a.ser(href="https://github.com/broadwayinc/skapi-js" target="_blank" data-track="navBar_github_icon" @click="closeMobileMenu")
                                    img(src="@/assets/img/landingpage/icon_github.svg" alt="Github icon")
                                    | Github
                            li.list.go-service.mo-item(v-if="user?.user_id")
                                router-link.ser(to="/my-services" data-track="navBar_my_services_icon" @click="closeMobileMenu") 
                                    img(src="@/assets/img/logo/symbol-logo-white.svg" alt="My Services icon")
                                    | My Services
                        .community(:class="{'absolute': currentRoutePath !== 'my-services'}")
                            span.text Community
                            ul.list-wrap
                                li.item
                                    a.link(href="http://www.tiktok.com/@skapi_api" target="_blank" data-track="navBar_tiktok_icon")
                                        img(src="@/assets/img/landingpage/icon_tiktok.svg" alt="TikTok icon")
                                li.item
                                    a.link(href="https://www.instagram.com/skapi_api" target="_blank" data-track="navBar_instagram_icon")
                                        img(src="@/assets/img/landingpage/icon_instagram.svg" alt="Instagram icon")
                                li.item
                                    a.link(href="https://www.youtube.com/@skapi_official" target="_blank" data-track="navBar_youtube_icon")
                                        img(src="@/assets/img/landingpage/icon_youtube.svg" alt="YouTube icon")
                                li.item
                                    a.link(href="https://x.com/skapi_api" target="_blank" data-track="navBar_x_icon")
                                        img(src="@/assets/img/landingpage/icon_x.svg" alt="X (formerly Twitter) icon")
                                li.item
                                    a.link(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank" data-track="navBar_linkedin_icon")
                                        img(src="@/assets/img/landingpage/icon_linkedin.svg" alt="LinkedIn icon")
                                li.item
                                    a.link(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank" data-track="navBar_facebook_icon")
                                        img(src="@/assets/img/landingpage/icon_facebook.svg" alt="Facebook icon")
                                li.item
                                    a.link(href="https://dev.to/skapi_api" target="_blank" data-track="navBar_devto_icon")
                                        img(src="@/assets/img/landingpage/icon_devto.svg" alt="Dev.to icon")
//- #proceeding(v-if="!running")
    .inner    
        .loader(style="--loader-color:white; --loader-size: 20px")
        h4 Page Loading
#loading(v-if="running")
    .loader
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { onMounted, onBeforeUnmount, ref, watch, nextTick } from "vue";
import { skapi } from "@/main";
import { 
    // serviceMainLoaded,
    currentService
} from "@/views/service-list";
import { user, customer } from "@/code/user";
import { showDropDown } from "@/components/jsComponents";
import { setAutoHide, removeListener, routeName } from "./navBar-autohide.ts";

import SideNav from "@/components/sideNav.vue";

const router = useRouter();
const route = useRoute();

let navBar = ref(null);
let moreVert = ref(null);
let running = ref(false);
// let serviceName = ref(currentService.value?.service?.name || "loading...");
const userEmail = ref(user?.email || "");
const isDesktop = ref(window.innerWidth > 800);

const navSecEl = ref(null);
const navMenuEl = ref(null);
const communityEl = ref(null);
const communityDropdownVisible = ref(false);
const profileDropdownVisible = ref(false);
let currentRoutePath = ref("");
let communityHideTimeout = null;
let profileHideTimeout = null;
const landingPageRef = ref(null);

// const updateServiceName = () => {
//     serviceName.value = currentService.value?.service?.name || "loading...";
// };

// watch currentService.value.service.name to update serviceName
// watch(() => currentService.value?.service?.name, (nv) => {
//     serviceName.value = nv || "loading...";
// });

let openMoMenu = () => {
    const body = document.querySelector("body");
    const moMenuWrap = document.querySelector("#navBar .wrap .right");

    moMenuWrap.classList.toggle("open");
    body.style.overflow = moMenuWrap.classList.contains("open")
        ? "hidden"
        : "auto";
};

let openBillingPage = async () => {
    running.value = true;

    let resolvedCustomer = await customer;

    skapi
        .clientSecretRequest({
            clientSecretName: "stripe_test",
            url: `https://api.stripe.com/v1/billing_portal/sessions`,
            method: "POST",
            headers: {
                Authorization: "Bearer $CLIENT_SECRET",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: {
                customer: resolvedCustomer.id,
                return_url: window.location.origin + route.path,
            },
        })
        .then((response) => {
            window.location = response.url;
            setTimeout(function () {
                running.value = false;
            }, 3000);
        });
};

let navigateToPage = () => {
    moreVert.value.style.display = "none";

    const moMenuWrap = document.querySelector(".right");
    const body = document.querySelector("body");

    if (moMenuWrap.classList.contains("open")) {
        moMenuWrap.classList.remove("open");
        body.style.overflow = "auto";
    }

    router.push({ path: "/account-setting" });
};

let logout = () => {
    // 로그아웃 전에 pending requests 종료
    skapi.util.terminatePendingRequests();

    skapi.logout().then(() => {
        router.push({ path: "/" });
    });

    const body = document.querySelector("body");
    const moMenuWrap = document.querySelector(".right");

    moMenuWrap.classList.toggle("open");
    body.style.overflow = moMenuWrap.classList.contains("open")
        ? "hidden"
        : "auto";
};

const closeMobileMenu = () => {
    const moMenuWrap = document.querySelector(".right");
    const body = document.querySelector("body");

    if (moMenuWrap && moMenuWrap.classList.contains("open")) {
        moMenuWrap.classList.remove("open");
        body.style.overflow = "auto";
    }
};

const scrollSec = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
        const remOffset =
            4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const scrollY = section.offsetTop - remOffset;
        window.scrollTo({ top: scrollY, behavior: "smooth" });
    }

    closeMobileMenu();
};

function handleMouseOver(container, selector, event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    const hovered = event.target.closest(selector);
    if (hovered) {
        if (
            hovered.classList.contains("go-login") ||
            hovered.classList.contains("user-profile") ||
            hovered.classList.contains("mo-item")
        ) {
            const elements = container.querySelectorAll(selector);
            elements.forEach((el) => (el.style.opacity = 1));
            return;
        }

        // 일반 리스트 hover 처리
        const elements = container.querySelectorAll(selector);
        elements.forEach((el) => {
            if (
                el.classList.contains("go-login") ||
                el.classList.contains("user-profile") ||
                el.classList.contains("mo-item")
            ) {
                el.style.opacity = 1;
            } else {
                el.style.opacity = 0.5;
            }
        });
        hovered.style.opacity = 1;
    }
}

function handleMouseOut(container, selector, event) {
    const currentTarget = event.currentTarget;
    const related = event.relatedTarget;

    if (currentTarget && related && currentTarget.contains(related)) {
        return; // 컨테이너 내부 이동 → 무시
    }

    const elements = container.querySelectorAll(selector);
    elements.forEach((el) => (el.style.opacity = 1));
}

// community dropdown
const showCommunityDropdown = () => {
    if (communityHideTimeout) {
        clearTimeout(communityHideTimeout);
        communityHideTimeout = null;
    }
    communityDropdownVisible.value = true;
};

const hideCommunityDropdown = () => {
    // 약간의 지연을 두어 사용자가 popup으로 마우스를 이동할 시간을 제공
    communityHideTimeout = setTimeout(() => {
        communityDropdownVisible.value = false;
    }, 100);
};

// profile dropdown
const showProfileDropdown = () => {
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
        profileHideTimeout = null;
    }
    profileDropdownVisible.value = true;
};

const hideProfileDropdown = () => {
    // 약간의 지연을 두어 사용자가 popup으로 마우스를 이동할 시간을 제공
    profileHideTimeout = setTimeout(() => {
        profileDropdownVisible.value = false;
    }, 100);
};

// 로고 클릭 시 resetVideo 호출하는 함수
const handleLogoClick = () => {
    // 현재 홈페이지인 경우에만 비디오 리셋
    if (route.name === "home") {
        // landingPage 컴포넌트의 resetVideo 함수 호출
        const landingPageComponent = document.querySelector(
            "[data-landing-page]"
        );
        if (landingPageComponent && landingPageComponent.__vueParentComponent) {
            landingPageComponent.__vueParentComponent.exposed?.resetVideo?.();
        }
    }
    // router.push("/");
};

window.addEventListener("resize", () => {
    isDesktop.value = window.innerWidth > 800;
});

onMounted(() => {
    setAutoHide(navBar.value, 3);
    // window.addEventListener("serviceChanged", updateServiceName);

    if (navSecEl.value) {
        navSecEl.value.addEventListener("mouseover", (e) =>
            handleMouseOver(navSecEl.value, ".section-item", e)
        );
        navSecEl.value.addEventListener("mouseout", (e) =>
            handleMouseOut(navSecEl.value, ".section-item", e)
        );
    }

    if (navMenuEl.value) {
        navMenuEl.value.addEventListener("mouseover", (e) =>
            handleMouseOver(navMenuEl.value, ".list", e)
        );
        navMenuEl.value.addEventListener("mouseout", (e) =>
            handleMouseOut(navMenuEl.value, ".list", e)
        );
    }

    if (communityEl.value) {
        communityEl.value.addEventListener("mouseover", (e) =>
            handleMouseOver(communityEl.value, ".link", e)
        );
        communityEl.value.addEventListener("mouseout", (e) =>
            handleMouseOut(communityEl.value, ".link", e)
        );
    }
});

onBeforeUnmount(() => {
    if (communityHideTimeout) {
        clearTimeout(communityHideTimeout);
    }
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
    }

    removeListener();
    // window.removeEventListener("serviceChanged", updateServiceName);

    if (navSecEl.value) {
        navSecEl.value.removeEventListener("mouseover", (e) =>
            handleMouseOver(navSecEl.value, ".section-item", e)
        );
        navSecEl.value.removeEventListener("mouseout", (e) =>
            handleMouseOut(navSecEl.value, ".section-item", e)
        );
    }

    if (navMenuEl.value) {
        navMenuEl.value.removeEventListener("mouseover", (e) =>
            handleMouseOver(navMenuEl.value, ".list", e)
        );
        navMenuEl.value.removeEventListener("mouseout", (e) =>
            handleMouseOut(navMenuEl.value, ".list", e)
        );
    }

    if (communityEl.value) {
        communityEl.value.removeEventListener("mouseover", (e) =>
            handleMouseOver(communityEl.value, ".link", e)
        );
        communityEl.value.removeEventListener("mouseout", (e) =>
            handleMouseOut(communityEl.value, ".link", e)
        );
    }
});

watch(
    () => route.name,
    (nv, ov) => {
        if (nv) {
            routeName.value = typeof nv === "string" ? nv : "";
        }

        // home 페이지로 돌아왔을 때 이벤트 리스너 재등록
        if (nv === "home") {
            nextTick(() => {
                if (navSecEl.value) {
                    navSecEl.value.addEventListener("mouseover", (e) =>
                        handleMouseOver(navSecEl.value, ".section-item", e)
                    );
                    navSecEl.value.addEventListener("mouseout", (e) =>
                        handleMouseOut(navSecEl.value, ".section-item", e)
                    );
                }
            });
        }
    },
    { immediate: true }
);

watch(
    () => route.path,
    (nv) => {
        let splitPath = nv.split("/");

        currentRoutePath.value = splitPath.length > 2 ? splitPath[1] : "";
    },
    { immediate: true }
);
</script>

<style lang="less" scoped>
img.symbol.mobile {
    display: none;
}

#proceeding {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 9999999;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
}

#loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;

    .loader {
        --loader-color: #fff;
        --loader-size: 1rem;
        width: var(--loader-size);
        height: var(--loader-size);
    }
}

#navBar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100%;
    height: 4rem;
    background-color: #000;
    box-shadow: 0px 0.5px 0px 0px #1a1a1a;
    font-size: 1.125rem;
    color: #fff;
    fill: #fff; // for svg

    a {
        color: #fff;
    }

    &.main-nav {
        .wrap {
            max-width: 100rem;
        }
    }

    .wrap {
        // max-width: 100rem;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding: 0 2.5rem;
        margin: 0 auto;

        .left {
            flex-grow: 1;
            display: flex;
            align-items: center;
            gap: 3.75rem;
            height: 100%;

            .logo-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }
            }

            .logo {
                display: flex;
                gap: 10px;
                // color: #000;
                align-items: center;
                text-decoration: none;
            }

            .section-list {
                display: flex;
                align-items: center;
                padding-left: 0;
                margin: 0;
                height: 100%;

                .section-item {
                    list-style: none;
                    cursor: pointer;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin-right: 2.75rem;

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        .right {
            display: inline-block;
            vertical-align: middle;
            height: 100%;

            .menu-wrap {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding-left: 0;
                margin: 0;
                height: 100%;

                li {
                    list-style: none;
                    vertical-align: middle;
                    user-select: none;
                    position: relative;
                    height: 100%;
                }
            }

            .list {
                &:first-child {
                    .ser {
                        padding-left: 0;
                    }
                }

                &::after {
                    content: "";
                    display: inline-block;
                    width: 1px;
                    height: 20px;
                    background-color: rgba(225, 225, 225, 0.2);
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                }

                &.user-profile {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    padding-right: 0;
                    padding-left: 1.25rem;
                    position: relative;

                    .img-profile-wrap {
                        overflow: hidden;
                        position: relative;

                        &:hover {
                            &::after {
                                content: "";
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                background-color: rgba(255, 255, 255, 0.05);
                                position: absolute;
                                top: 50%;
                                left: 0;
                                transform: translateY(-50%);
                                z-index: 1;
                                border-radius: 50%;
                            }
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            display: block;
                        }
                    }

                    img {
                        display: block;
                        overflow: hidden;
                    }

                    &::after {
                        display: none;
                    }
                }
            }

            .ser {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                cursor: pointer;
                height: 100%;
                padding: 0 1.25rem;

                &:hover {
                    text-decoration: none;
                }

                img {
                    width: 1.25rem;
                    height: 1.25rem;
                }
            }

            .go-community {
                .btn-dropdown {
                    background: none;
                    border: none;
                    padding: 0;
                    margin: 0;
                    font: inherit;
                    color: inherit;
                    height: auto;
                }

                .item {
                    cursor: pointer;
                }
            }

            .go-login {
                border-radius: 100px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                margin-left: 1.25rem;
                height: initial !important;

                a {
                    padding: 0;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    cursor: pointer;
                    height: 100%;
                    padding: 0.5rem 1.125rem 0.5rem 1rem;

                    &:hover {
                        text-decoration: none;
                    }
                }

                &:after {
                    content: none;
                }

                &:hover {
                    background-color: #1c1b1b;
                }
            }
        }

        .profile {
            max-width: 19.375rem;
            text-align: left;
            color: #fff;
            font-size: 1rem;
            font-weight: 400;
            user-select: none;
            background-color: #16171a;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 0.875rem;

            .account {
                padding: 14px 20px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                display: flex;
                align-items: center;
            }

            .user-id {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .dropdown-menu {
            display: block;
            text-align: left;
            padding: 0.625rem 0 0.8125rem;

            .dropdown-list {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.625rem 1.25rem;

                span {
                    font-size: 1.0625rem;
                    font-weight: 500;
                    white-space: nowrap;
                }

                &:hover {
                    background: rgba(255, 255, 255, 0.05);
                    cursor: pointer;
                }
            }
        }

        .community {
            background-color: #16171a;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 0.875rem;

            .list-wrap {
                padding: 1rem 1.25rem;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                // gap: 0.75rem 0;
            }

            .item {
                display: flex;
                justify-content: center;
                align-items: center;

                .link {
                    display: inline-block;
                    padding: 0.375rem;
                }

                img {
                    width: 2.25rem;
                    height: 2.25rem;
                }

                &.mo-item {
                    .link {
                        padding: 0.25rem 1rem 0.25rem 0;
                    }
                }
            }
        }
    }

    .go-community {
        .dropdown-container {
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
        }

        .moreVert.community {
            position: absolute;
            top: 100%;
            right: 0;
            z-index: 1000;
            /* 기존 moreVert 스타일 유지 */
        }
    }
}

@media (max-width: 1360px) {
    #navBar {
        .wrap {
            .left {
                gap: 3rem;

                .section-list {
                    .section-item {
                        margin-right: 2rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 1280px) {
    #navBar {
        .wrap {
            .left {
                .section-list {
                    display: none;
                }
            }
        }
    }
}

@media (max-width: 800px) {
    #navBar {
        .wrap {
            padding: 0 1.25rem;

            .left {
                .section-list {
                    display: none;
                }
            }

            .right {
                .mo {
                    padding-right: 0;

                    &:after {
                        content: none;
                    }
                }

                .btn-open-menu {
                    background: none;
                    border: none;
                    padding: 0;
                    margin: 0;
                    font: inherit;
                    color: inherit;
                    height: 100%;

                    img {
                        width: 2rem;
                        height: 2rem;
                    }
                }

                &.open {
                    .mo-menu-wrap {
                        right: 0;
                    }
                }
            }

            .community {
                border: none;
                background-color: inherit;
                border-radius: 0;
                padding: 1.25rem 1.25rem 0.75rem 1.25rem;

                &.absolute {
                    position: absolute;
                    width: calc(100% - 4.5rem);
                    bottom: 60px;
                }

                .text {
                    font-size: 0.875rem;
                    font-weight: 400;
                    color: rgba(225, 225, 225, 0.7);
                    display: inline-block;
                    margin-bottom: 1.25rem;
                }

                .list-wrap {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 0;
                }

                .item {
                    padding: 0;
                }
            }
        }

        .mo-menu-wrap {
            position: absolute;
            right: -110%;
            top: 0;
            width: 100%;
            height: 100vh;
            background: #000;
            // padding-bottom: 3.75rem;
            padding-bottom: 1.8rem;
            transition: right 0.3s ease-in-out;
            z-index: 9999;
            overflow-y: auto;

            .top-area {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 4rem;
                padding: 0 1.25rem;

                img.symbol.mobile {
                    display: block;
                }
            }

            .right-area {
                display: flex;
                align-items: center;
                height: 100%;
                gap: 1.25rem;

                .prof {
                    display: flex;
                    cursor: pointer;
                    top: 0.25rem;
                }

                .img-profile {
                    .img-wrap {
                        position: relative;
                        overflow: hidden;

                        img {
                            display: block;
                        }

                        &:hover {
                            &::after {
                                content: "";
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                background-color: rgba(255, 255, 255, 0.05);
                                top: 50%;
                                left: 0;
                                transform: translateY(-50%);
                                z-index: 1;
                                border-radius: 50%;
                            }
                        }
                    }
                }

                .profile {
                    top: 4rem;
                    right: 1.25rem;
                }

                .go-login {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.5rem 1.125rem 0.5rem 1rem;

                    &:hover {
                        text-decoration: none;
                    }

                    img {
                        width: 1.25rem;
                        height: 1.25rem;
                    }
                }
            }

            .btn-close {
                background: none;
                border: none;
                padding: 0;
                margin: 0;
                font: inherit;
                color: inherit;
                height: 100%;
                display: flex;
                align-items: center;

                img {
                    width: 2rem;
                    height: 2rem;
                }
            }

            ul {
                height: initial;
                font-size: 1rem;
                font-weight: 400;
                padding-left: 0;
            }

            li {
                padding: 0.75rem 2.25rem;
            }

            .section-list {
                &:after {
                    content: "";
                    display: inline-block;
                    width: calc(100% - 3rem);
                    height: 1px;
                    background-color: rgba(255, 255, 255, 0.1);
                    position: relative;
                    bottom: -0.375rem;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }

            .menu-list {
                padding-top: 1.25rem;
                padding-bottom: 1.25rem;

                .list {
                    padding: 0;
                    font-size: 1rem;

                    &:first-child {
                        .ser {
                            // padding-left: 1.5rem;
                            padding-left: 2.25rem;
                        }
                    }

                    &::after {
                        content: none;
                    }

                    &:hover {
                        background: rgba(255, 255, 255, 0.05);
                        cursor: pointer;
                    }

                    a {
                        padding: 0.75rem 2.25rem;
                    }
                }

                .ser {
                    padding: 1rem 1.5rem;
                }

                .go-github {
                    padding-left: 0;
                }
            }

            .community {
                border-top: 1px solid rgba(255, 255, 255, 0.1);
                padding: 0.75rem 0;
                margin: 0 2.25rem;

                .list-wrap {
                    li {
                        &:first-child {
                            a {
                                padding-left: 0;
                            }
                        }
                    }

                    .item {
                        margin-right: 12px;

                        .link {
                            padding: 0;
                        }
                    }
                }
            }

            .mo-item {
                &:hover {
                    background: transparent;
                }
            }
        }
    }
}

@media (max-width: 430px) {
    #navBar {
        .mo-menu-wrap {
            .right-area {
                .profile {
                    max-width: calc(100% - 2rem);
                }

                .dropdown-list {
                    img {
                        width: 1.25rem;
                        height: 1.25rem;
                    }
                }

                .go-login {
                    font-size: 1.0625rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;

                    &:hover {
                        text-decoration: none;
                    }

                    img {
                        width: 1.25rem;
                        height: 1.25rem;
                    }
                }
            }

            .menu-list {
                .list {
                    &:first-child {
                        .ser {
                            padding-left: 2rem;
                        }
                    }

                    a {
                        padding: 0.75rem 2rem;
                    }
                }
            }

            .community {
                padding: 0.75rem 0;
            }

            li {
                padding-left: 2rem;
            }
        }
    }
}
</style>
